import _ from 'lodash';
/*
    Params: array, int, int
    Returns new array with item in old_index moved to new_index
*/
export function array_move(arr, old_index, new_index) {
    let newArr = arr.slice()
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            newArr.push(undefined);
        }
    }
    newArr.splice(new_index, 0, newArr.splice(old_index, 1)[0]);
    return newArr;
};

//checks to see if attribute is unique in value array
export function isAttributeUnique(values, attribute) {
    return _.uniqBy(values, attribute).length === values.length;
}

//checks if a single question's ref exists in the database, and if it does, checks if the data matches
export function checkQuestion(field, questions, language) {
    let foundRef = questions.find((q) => q.ref === field.ref && q.language === language);
    if (foundRef) {
        if (foundRef.title !== field.title) {
            return false;
        } else if (foundRef.type !== field.type) {
            return false;
        } else if (field.type === "multiple_choice" && !checkMultipleChoice(foundRef.properties, field.properties)) {
            return false;
        } else if (field.type === 'opinion_scale' && !checkOpinionScale(foundRef.properties, field.properties)) {
            return false;
        } else if (field.type === 'group' && !checkGroup(foundRef.properties, field.properties, questions, language)) {
            return false;
        }
    }
    return true;
}

//checks if all questions in the fields array matches data in the database for a given language
export function checkQuestions(fields, question_store, language) {
    let notMatched = [];
    fields.forEach(field => {
        let foundRef = question_store.find((q) => q.ref === field.ref && q.language === language);
        if (foundRef) {
            if (foundRef.title !== field.title) {
                notMatched.push(field.ref);
            } else if (foundRef.type !== field.type) {
                notMatched.push(field.ref);
            } else if (field.type === "multiple_choice" && !checkMultipleChoice(foundRef.properties, field.properties)) {
                notMatched.push(field.ref);
            } else if (field.type === 'opinion_scale' && !checkOpinionScale(foundRef.properties, field.properties)) {
                notMatched.push(field.ref);
            } else if (field.type === 'group' && !checkGroup(foundRef.properties, field.properties, question_store, language)) {
                notMatched.push(field.ref);
            }
        }
    });
    return notMatched;
}

//checks if multiple choice question matches data in the database
function checkMultipleChoice(existingField, newField) {
    if (existingField.allow_multiple_selection !== newField.allow_multiple_selection) return false;
    if (existingField.allow_other_choice !== newField.allow_other_choice) return false;
    if (existingField.choices.length !== newField.choices.length) return false;
    let match = true;
    existingField.choices.forEach((choice, idx) => {
        if (choice.label !== newField.choices[idx].label) {
            match = false;
        }
    });
    return match;
}

//checks if opinion scale question matches data in the database
function checkOpinionScale(existingField, newField) {
    if (existingField.start_at_one !== newField.start_at_one) return false;
    if (existingField.steps !== newField.steps) return false;
    return true;
}

//checks if questions in a group match data in the database
function checkGroup(existingField, newField, question_store, language) {
    if (!newField.fields) return true;
    let notMatched = checkQuestions(newField.fields, question_store, language);
    if (notMatched.length > 0) return false;
    return true;
}

//checks logic array to make sure mentioned refs exist
export function checkLogicArray(logic_jumps, fields) {
    let keep = [];
    logic_jumps.forEach(logic => {
        if (checkLogic(logic, fields)) {
            keep.push(logic);
        }
    });
    return keep;
}

//checks single logic object to make sure mentioned refs exist
function checkLogic(logic, fields) {
    if (logic.actions.length === 0) return false;
    let field = fields.find(f => f.ref === logic.ref);
    if (!field) return false;
    let keepLogic = true;
    logic.actions.forEach(action => {
        if (action.details && !fields.find(f => f.ref === action.details.to.value)) {
            keepLogic = false;
        }
        if (field.type === 'multiple_choice' && action.condition.op === 'is') {
            if (!field.properties.choices.some(choice => choice.ref === action.condition.vars[1].value)) {
                keepLogic = false;
            }
        }
    });
    return keepLogic;
}

/*
    filters questions array based on search term
    filters by question ref, title, and language
    if question is multiple choice, will also filter by choices
*/
export function filterQuestions(term) {
    return (item) => {
        if (term === '') return true;
        term = term.toLowerCase();
        const terms = term.split(' ');
        return terms.every(term => {
            if (item.type === 'multiple_choice') {
                return (
                    item['properties']['choices'].some(e => e.label.toLowerCase().includes(term))
                    || item['ref'].toLowerCase().includes(term)
                    || item['title'].toLowerCase().includes(term)
                    || item['language'].toLowerCase().includes(term)
                )
            } else {
                return (
                    item['ref'].toLowerCase().includes(term)
                    || item['title'].toLowerCase().includes(term)
                    || item['language'].toLowerCase().includes(term)
                )
            }
        })
    }
}

export function filterArchivedQuestions(term) {
    return (item) => {
        if (term === '') return true;
        term = term.toLowerCase();
        const terms = term.split(' ');
        return terms.every(term => {
            const questionData = item['questionData'];
            if (questionData.type === 'multiple_choice') {
                return (
                    questionData['properties']['choices'].some(e => e.label.toLowerCase().includes(term))
                    || questionData['ref'].toLowerCase().includes(term)
                    || questionData['title'].toLowerCase().includes(term)
                    || questionData['language'].toLowerCase().includes(term)
                )
            } else {
                return (
                    questionData['ref'].toLowerCase().includes(term)
                    || questionData['title'].toLowerCase().includes(term)
                    || questionData['language'].toLowerCase().includes(term)
                )
            }
        })
    }
}

export function filterQSet(term) {
    return (item) => {
        if (term === '') return true;
        term = term.toLowerCase();
        const terms = term.split(' ');
        return terms.every(term =>
            (
                item['id'].toLowerCase().includes(term)
                || item['description'].toLowerCase().includes(term)
                || item['fields'].some(e => e.toLowerCase().includes(term))
            )
        );
    }
}

export function filterTypeformSurveys(term) {
    return (item) => {
        // Return all surveys.
        if (term === '') return true;
        term = term.toLowerCase();
        const terms = term.split(' ');
        return terms.every(term =>
            (
                item['id'].toLowerCase().includes(term)
                || item['title'].toLowerCase().includes(term)
                || (item['campaignType'] && item['campaignType'].toLowerCase().includes(term))
                || (item['customer'] && item['customer'].toLowerCase().includes(term))
            )
        );
    }
}

export function filterVaultSurveys(term) {
    return (item) => {
        if (term === '') return true;
        term = term.toLowerCase();
        const terms = term.split(' ');
        return terms.every(term =>
            (
                item['id'].toLowerCase().includes(term)
                || item['name'].toLowerCase().includes(term)
            )
        );
    }
}

export function filterCustomers(term) {
    return (item) => {
        // Return all customers.
        if (term === '') return true;
        term = term.toLowerCase();
        const terms = term.split(' ');
        return terms.every(term =>
            (
                item['name'].toLowerCase().includes(term)
                || item['level_0'].toLowerCase().includes(term)
            )
        );
    }
}

export function filterCustomerCampaigns(term) {
    return (item) => {
        // Return all customer campaigns.
        if (!item) return false;
        term = term.toLowerCase();
        const terms = term.split(' ');
        return terms.every(term =>
            (
                item['type'].toLowerCase().includes(term)
                || item['name'].toLowerCase().includes(term)
            )
        );
    }
}

export function filterMultiSelectLabels(term) {
    return (item) => {
        if (term === '') return true;
        term = term.toLowerCase();
        const terms = term.split(' ');
        return terms.every(term => {
            return (
                Object.entries(item['labels']).some(e => e[0].toLowerCase().includes(term) || e[1].toLowerCase().includes(term))
                || item['ref'].toLowerCase().includes(term)
            )
        })
    }
}

/*
    takes in an array of strings
    returns a comma separated list
*/
export function flattenArray(arr) {
    let combined = "";
    arr.forEach((item, idx) => {
        if (idx === arr.length - 1) {
            combined = combined + item;
        } else {
            combined = combined + item + ', ';
        }
    })
    return combined;
}

export function isResponseOkay(response) {
    return response && response.status >= 200 && response.status < 300;
}

// send patch request to typeform API to update survey workspace
// if patch is successful, return true
export async function changeWorkspace(payload) {
    const { workspace, surveyId } = payload;
    const patch = [{
        "op": "replace",
        "path": "/workspace",
        "value": {
            "href": `https://api.typeform.com/workspaces/${workspace}`
        }
    }]
    const body = {
        body: JSON.stringify(patch),
        method: 'POST'
    }
    let answer = await fetch(`/.netlify/functions/typeform?type=patch&uid=${surveyId}`, body).then(response =>
        response.json()
    ).catch(err => console.error("Failed to change workspace: ", err));
    if (isResponseOkay(answer)) {
        return true;
    }
    return false;
}

export async function updateSurveysWorkspace(payload) {
    const { isActive, surveys } = payload;
    let workspace;
    if (isActive) {
        workspace = process.env.REACT_APP_ACTIVE_WORKSPACE
    } else {
        workspace = process.env.REACT_APP_ARCHIVED_WORKSPACE
    }
    return Promise.all(surveys.map(surveyId => 
        changeWorkspace({ workspace, surveyId })
    ));
}

export function getWorkspace(workspace) {
    let split = workspace.href.split('/');
    return split[split.length - 1];
}

// function updateGroupQuestions(){
//     let batch = db.batch();
//     let counter = 0;
//     this.state.questions.forEach(question => {
//         if(question.type === 'group'){
//             let id = question.id;
//             question.properties = {
//                 fields: [],
//                 button_text: "Continue",
//                 show_button: true
//             }
//             let doc_ref = db.collection("question_store").doc(id);
//             batch.set(doc_ref, question);
//             counter++;
//         }
//     })
//     batch.commit().then(function (resp) {
//         console.log(counter);
//         console.log("committed!");
//     })
// }

// updateOpinionQuestions = () => {
//     let batch = db.batch();
//     let counter = 0;
//     this.state.questions.forEach(question => {
//         if (question.type === 'opinion_scale' && question.properties.steps === 5) {
//             let id = question.id;
//             question.properties.start_at_one = true;
//             let doc_ref = db.collection("question_store").doc(id);
//             batch.set(doc_ref, question);
//             counter++;
//         }
//     })
//     batch.commit().then(function (resp) {
//         console.log(counter);
//         console.log("committed!");
//     })
// }

// addMultiLabels = async() => {
//     let data = [];
//     let refs = Object.entries(MULTISELECT_LABELS);
//     console.log(refs);
//     refs.forEach(ref => {
//         let newObj = {
//             labels: ref[1],
//             ref: ref[0]
//         }
//         data.push(newObj);
//     });
//     let batch = db.batch();
//     var bar = new Promise((resolve, reject) => {
//         data.forEach((question, index, array) => {
//             let id = question.ref;
//             let doc_ref = db.collection("multiselect_labels").doc(id);
//             doc_ref.get().then(doc => {
//                 if (doc.exists) {
//                     console.log(`Question exists already: ${id}`);
//                 } else {
//                     console.log(`${index}. Setting ${id}`);
//                     batch.set(doc_ref, question);
//                 }
//                 if (index === array.length - 1) {
//                     console.log(index);
//                     resolve();
//                 }
//             })
//         })
//     });
//     await bar.then(() => {
//         batch.commit().then(function (resp) {
//             console.log("committed!");
//             console.log(resp);
//         })
//     })
//     console.log('Done!')
// }